import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, apiErrorText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/dashboard", { state: { user: data } });
      } catch (e) {
        setError(apiErrorText(e));
        setTimeout(() => navigate("/login"), 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 rounded-sm bg-foreground text-background flex items-center justify-center">
          <ShieldCheck className="h-6 w-6" />
        </div>
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Establishing secure session…</div>
        {error && <div className="text-xs text-destructive font-mono max-w-sm text-center">{error}</div>}
      </div>
    </div>
  );
}
